(function (root) {
  'use strict';

  function createHistory(storage, key, allowed = () => true, limit = 6) {
    let memory = [];
    const clean = (values) => {
      if (!Array.isArray(values)) return [];
      const seen = new Set();
      return values.filter((value) => typeof value === 'string')
        .map((value) => value.trim().slice(0, 100))
        .filter((value) => {
          const normalized = value.toLocaleLowerCase();
          if (!value || seen.has(normalized)) return false;
          seen.add(normalized);
          return true;
        }).slice(0, limit);
    };
    const read = () => {
      if (allowed()) {
        try {
          const value = storage?.getItem(key);
          if (value !== null && value !== undefined) memory = clean(JSON.parse(value));
        } catch (_) { /* Storage is optional; retain the in-memory history. */ }
      }
      return [...memory];
    };
    const save = () => {
      if (allowed()) {
        try { storage?.setItem(key, JSON.stringify(memory)); } catch (_) { /* Quota or privacy restriction. */ }
      }
      return [...memory];
    };
    return {
      read,
      add(value) { memory = clean([value, ...read()]); return save(); },
      clear() {
        memory = [];
        try { storage?.removeItem(key); } catch (_) { /* Best-effort deletion. */ }
        return [];
      },
    };
  }

  function searchURL(route, term, origin) {
    const url = new URL(route, origin);
    url.searchParams.set('q', String(term).trim());
    url.searchParams.set('type', 'product,article,page');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    return url.toString();
  }

  function normalizeSearchURL(value) {
    const url = new URL(value);
    if (!url.pathname.endsWith('/search')) return url;
    // Shopify can serialize nested search options as a scalar Ruby hash in
    // pagination/canonical URLs. Never send that scalar back with nested keys.
    url.searchParams.delete('options');
    if (!url.searchParams.has('type')) url.searchParams.set('type', 'product,article,page');
    if (!url.searchParams.has('options[prefix]')) url.searchParams.set('options[prefix]', 'last');
    const sort = url.searchParams.get('sort_by');
    url.searchParams.set('options[unavailable_products]', !sort || sort === 'relevance' ? 'last' : 'show');
    return url;
  }

  const api = { createHistory, searchURL, normalizeSearchURL };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.WcDiscovery = api;
})(typeof window !== 'undefined' ? window : globalThis);
